import React from 'react';

export const HFIcon = () => {
  return (
    <div>
      <img src="/pictures/HFIcon.svg" alt="" />
    </div>
  );
};
